import React, { useState } from "react";
import Pagination from "react-js-pagination";
import { useHistory } from "react-router-dom";

import { connect } from "react-redux";
import { frontloadConnect } from "react-frontload";
import { useSelector } from "react-redux";
import { Helmet } from "react-helmet";

import { getBanner } from "./../../store/banner.reducers";
import { getRepresentatives } from "./../../store/representatives.reducers";
import { handlePaginateChange, handleGetPaginate, stripAccents } from "./../../services/functions";

import Header from "./../../components/Header";
import Featured from "./../../components/Featured";
import Title from "./../../components/Title";
import Newsletter from "./../../components/Newsletter";
import Footer from "./../../components/Footer";
import MainServices from "./../../components/MainServices";

import {
  Main,
  Container,
  Content,
  Aside,
  ContentBody,
  ContentMain,
  ListItem,
  ListItemFigure,
  ListItemImage,
  ListItemContent,
  ListItemTitle,
  ListItemSubTitle,
  ListItemLine,
  Box,
  BoxTitle,
  BoxContent,
  FilterLabel,
  FilterInput,
  FilterButton,
} from "./styles";

let PATH = "/representantes/";

const frontload = async props => {
  await props.getRepresentatives(`${process.env.REACT_APP_API}/representatives`, {
    headers: { pagenumber: props.match.params.page || 1, pagelimit: 10, term: stripAccents(props.match.params.filter || "") },
  });
  return;
};

function Representatives(props) {
  if (props.match.params.filter) {
    PATH = `/representantes/buscar/${props.match.params.filter}/`;
  }

  let { representativesReducers: representatives } = useSelector(state => state);
  const paginate = representatives.representatives;
  representatives = representatives.representatives.data;

  const [filterTerm, setFilterTerm] = useState();
  const history = useHistory();

  function sendSearch() {
    if (filterTerm) {
      history.push(`/representantes/buscar/${filterTerm}/`);
    } else {
      history.push(`/representantes/`);
    }
  }

  return (
    <>
      <Helmet>
        <title>
          Conheça os representantes - {process.env.REACT_APP_TITLE} {paginate.page ? `- Pág. ${paginate.page}` : ""}
        </title>
        <meta name="description" content={process.env.REACT_APP_DESCRIPTION} />
        <meta property="og:title" content={`Conheça os representantes - ${process.env.REACT_APP_TITLE} ${paginate.page ? `- Pág. ${paginate.page}` : ""}`} />
        <meta name="title" content={`Conheça os representantes - ${process.env.REACT_APP_TITLE} ${paginate.page ? `- Pág. ${paginate.page}` : ""}`} />
        <meta property="og:description" content={process.env.REACT_APP_DESCRIPTION} />
        <meta property="og:image" content="https://cromt.org.br/logo512.png" />
        <meta property="og:site_name" content="CRO-MT" />
        <meta property="og:url" content={global.window ? global.window.location : ""} />
      </Helmet>
      <Header />

      <Main id="main">
        <Container>
          <Content>
            <Title title={`Representantes`} />
            <ContentMain>
              <Aside>
                <Box>
                  <BoxTitle>Filtro</BoxTitle>
                  <BoxContent>
                    <FilterLabel>Busque por nome, e-mail, municipio...</FilterLabel>
                    <FilterInput type="text" value={filterTerm} onChange={event => setFilterTerm(event.target.value)} />

                    <FilterButton
                      onClick={() => {
                        sendSearch();
                      }}>
                      Filtrar
                    </FilterButton>
                  </BoxContent>
                </Box>

                <MainServices />
              </Aside>
              <ContentBody>
                {representatives.map(representative => (
                  <ListItem key={representative.id}>
                    {representative.image_path ? (
                      <ListItemFigure title={representative.name} alt={representative.name}>
                        <ListItemImage src={representative.image_path} title={representative.name} alt={representative.name} />
                      </ListItemFigure>
                    ) : (
                      <></>
                    )}

                    <ListItemContent>
                      <ListItemTitle>{representative.name}</ListItemTitle>
                      <ListItemSubTitle>{representative.city}</ListItemSubTitle>
                      <ListItemLine>{representative.emails}</ListItemLine>
                      <ListItemLine>{representative.phones}</ListItemLine>
                    </ListItemContent>
                  </ListItem>
                ))}

                <Pagination
                  activePage={paginate.page}
                  itemClass="pageItem"
                  itemsCountPerPage={paginate.perPage}
                  totalItemsCount={paginate.total}
                  pageRangeDisplayed={5}
                  onChange={pageNumber => handlePaginateChange(PATH, pageNumber, history)}
                  getPageUrl={i => {
                    return handleGetPaginate(PATH, i);
                  }}
                />
              </ContentBody>
            </ContentMain>
          </Content>
        </Container>
        <Newsletter />
      </Main>
      <Footer />
    </>
  );
}

// export default Home
const mapStateToProps = state => {
  return {
    banner: state.bannerReducers.banner,
    representatives: state.representativesReducers.representatives,
  };
};
const mapDispatchToProps = {
  getBanner,
  getRepresentatives,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(
  frontloadConnect(frontload, {
    onMount: true,
    onUpdate: false,
  })(Representatives),
);
